export default __webpack_public_path__ + "static/node@2x-2484f88c228588a7ba2e26e861ca7f9c.png";